import { styled, Theme } from "@mui/material";

import { shouldForwardPropHelper } from "utils/shouldForwardPropHelper";

interface TimelineDotProps {
  colorGetter?: (theme: Theme) => string;
}

const PROP_SET = new Set(["colorGetter"]);

export const TimelineDot = styled("div", {
  shouldForwardProp: (prop) => shouldForwardPropHelper(prop, PROP_SET),
})<TimelineDotProps>(({ theme, colorGetter }) => ({
  position: "absolute",
  width: TIMELINE_DOT_SIZE,
  height: TIMELINE_DOT_SIZE,
  borderRadius: 6,
  backgroundColor: theme.palette.ui60,

  ...(colorGetter && { backgroundColor: colorGetter(theme) }),
}));

const TIMELINE_DOT_SIZE = 8;
